module.exports = __webpack_public_path__ + "static/media/fast.69feb01f.png";